module.exports = __webpack_public_path__ + "img/feiwen.36e706fb.png";